import React, {Component} from "react";

import PropTypes from 'prop-types';

import {XDiv, XLi, XP, XUl} from "../Layout/Layout";
import Alert from "./Alert";

class  Alerts extends Component{

    constructor(props) {
        super(props);
        this.handleCloseItem = this.closeItem.bind(this);
        this.childId=0;
        this.childs =[];
        this.ides =[];
        React.Children.forEach(props.children,this.addChild.bind(this));
        this.state = {id: 0};
        this.props=props;
    }

    addChild(child) {
        this.childId++;
        this.ides.push(this.childId);
        let el = React.cloneElement(child,{
            closeItem:this.handleCloseItem,
            itemId: this.childId,
            key: this.childId,
        })
        this.childs.push(el);
    }

    appendXP(type,message) {
        let child=<Alert type={type} animEnter={this.props.animEnter} animExit={this.props.animExit} ><XP>{message}</XP></Alert>;
        this.addChild(child);
        this.setState({id:0});
    }

    appendUL(list) {
        const listItems = list.map((li,i) =>
            <XLi className="font-8" key={i}>{li}</XLi>
        );
        let child=<Alert type="danger" autoClose={0} animEnter={this.props.animEnter} animExit={this.props.animExit}  ><XUl  >{listItems}</XUl></Alert>;
        this.addChild(child);
        this.setState({id:0});
    }

    closeItem(itemId) {
        let l=this.ides.length;
        for (let i=0;i<l;i++){
            if(this.ides[i]===itemId){
                this.ides.splice(i, 1);
                this.childs.splice(i, 1);
                this.setState({id:itemId});
                break;
            }
        }
    }

    render() {
        const {
            layout,
            position,
        } = this.props;

        let c="alert-relative";
        if(layout==="static"){
            c=`alert-layout  ${position}`;
        }
        return (
            <React.Fragment>
                <XDiv className={c} >
                    {this.childs}
                </XDiv>
            </React.Fragment>
        )
    }
}

Alerts.propTypes = {
    layout: PropTypes.oneOf(['relative', 'static', ]),
    position: PropTypes.oneOf(['top', 'topLeft', 'topCenter', 'topRight', 'bottom', 'bottomLeft', 'bottomCenter',
        'bottomRight', 'center', 'centerLeft', 'centerRight']),
    animEnter: PropTypes.string,
    animExit: PropTypes.string,
};

Alerts.defaultProps = {
    layout:"static",
    position:"topLeft",
    animEnter:"animated zoomIn",
    animExit:"animated bounceOut",
};

export default Alerts;
